import React, { memo, Suspense } from 'react';
import { VARIABLE_CONFIG } from '../../../constants/analyticsConstants/Variables';
import AutoCompleteDropdown from '../../global/atoms/autoComplete/AutoCompleteDropdown';

const BannerSearch = ({
    searchState,
    intl,
    searchplaceholderlabel,
    customOnSearchClick,
    handleAnalyticsOnFocus,
    getSuggestions,
    renderSuggestion,
    myCustomStandaloneSearchBox,
    setIsOpen,
    isOpen,
    searchctalabel,
    source,
    handleSearchSubmit
}) => {
    return (
        <form role="search" className="bannerSearchContainer" onSubmit={handleSearchSubmit}>
            <span className="icon icon-search-icon bannerSearchContainer__icon" aria-hidden="true"></span>
            <AutoCompleteDropdown
                placeholderText={searchplaceholderlabel || intl.formatMessage({ id: 'location:search-placeholder' })}
                showResetBtn={true}
                onChange={e => {
                    myCustomStandaloneSearchBox.updateText(e.target.value);
                    setIsOpen(true);
                }}
                onSelect={selectedText => {
                    myCustomStandaloneSearchBox.updateText(selectedText);
                    myCustomStandaloneSearchBox.submit();
                    setIsOpen(false);
                }}
                onReset={() => {
                    myCustomStandaloneSearchBox.updateText('');
                    setIsOpen(true);
                }}
                showSearchIcon={false}
                isDropDownOpen={isOpen}
                renderSuggestion={renderSuggestion}
                suggestions={getSuggestions()}
                value={searchState.value}
                customOnSearchClick={customOnSearchClick}
                autoCompleteInputClass="cmp-Field__field__input"
                autoCompleteWrapperClass="header-autocomplete"
                source={VARIABLE_CONFIG.PLACEMENT.HEADER}
                handleEcomLocationAnalyticsOnFocus={() => handleAnalyticsOnFocus(source)}
                explicitSearchCTAText={searchctalabel}
                enableExplicitSearchCTA={true}
            />
        </form>
    );
};

export default BannerSearch;
